var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M7.95 21.988c.033-.01.103-.037.155-.062.06-.027 2.079-1.811 5.446-4.811 5.925-5.28 5.44-4.822 5.44-5.117s.485.162-5.44-5.117C9.528 3.297 8.17 2.099 8.08 2.057 7.978 2.007 7.935 2 7.748 2c-.186 0-.23.007-.335.056-.252.118-.4.331-.402.58-.003.306-.475-.14 5.14 4.861l5.053 4.5L12.15 16.5c-5.615 5.002-5.143 4.555-5.14 4.86.004.358.296.625.701.64.098.003.206-.002.238-.011",
    clipRule: "evenodd"
  })));
};
export default SvgChevronRight;